// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bGcSW","content":"styles_content__2TY8Q","row":"styles_row__1gIah","footer":"styles_footer__iSEjH","phraseLength":"styles_phraseLength__2aKe9"};